import React, { Component } from 'react';
import styled from 'styled-components';
import media from './MediaQueries';
import { Motion, spring } from 'react-motion';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';

const StyledFooter = styled.div`
  position: absolute;
  bottom: ${props => (props.minimized ? '-170px' : '0px')};
  left: 0;
  right: 0;
  margin: 0 auto;
  height: 164px;
  width: 100%;
  max-width: 992px;
  padding: 0 30px;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  align-items: center;
  transition: all 400ms ease-in-out;
  ${media.phone`
    bottom: 0;
  `}
`;

const StyledFooterWidgetContainer = styled.div`
  width: 100%;
  position: relative;
  height: 134px;
`;

const springSetting1 = { stiffness: 500, damping: 60 };

class Footer extends Component {
  constructor(props) {
    super(props);
    this.state = this.initState();
  }

  setDrag(boolean) {
    this.props.setDrag(boolean);
  }

  initState() {
    return {
      mouseXY: [0, 0],
      mouseCircleDelta: [0, 0], // difference between mouse and circle pos for x + y coords, for dragging
      lastPress: null, // key of the last pressed component
      isPressed: false,
    };
  }

  // TODO: the drag detection makes it hard to click the items sometimes.
  // if the finger / mouse moves even 1px while tapping, it will be 'drag' and
  // the user selection will be ignored.
  handleTouchStart = (key, pressLocation, e) => {
    this.setDrag(false);
    this.handleMouseDown(key, pressLocation, e.touches[0]);
  };

  handleTouchMove = e => {
    this.setDrag(true);
    e.preventDefault();
    this.handleMouseMove(e.touches[0]);
  };

  handleMouseMove = ({ pageX, pageY }) => {
    const {
      isPressed,
      mouseCircleDelta: [dx, dy],
    } = this.state;
    if (isPressed) {
      const mouseXY = [pageX - dx, pageY - dy];
      this.setState({ mouseXY });
      this.setDrag(true);
    }
  };

  handleMouseDown = (key, [pressX, pressY], { pageX, pageY }) => {
    this.setDrag(false);
    this.setState({
      lastPress: key,
      isPressed: true,
      mouseCircleDelta: [pageX - pressX, pageY - pressY],
      mouseXY: [pressX, pressY],
    });
  };

  handleMouseUp = () => {
    this.setState({ isPressed: false, mouseCircleDelta: [0, 0] });
  };

  disableSelect(event) {
    event.preventDefault();
  }

  componentDidMount() {
    window.addEventListener('touchmove', this.handleTouchMove);
    window.addEventListener('touchend', this.handleMouseUp);
    window.addEventListener('mousemove', this.handleMouseMove);
    window.addEventListener('mouseup', this.handleMouseUp);
    window.addEventListener('selectstart', this.disableSelect);
  }

  componentWillReceiveProps(props) {
    // Reset drag position on page switch, when filters has changed or pricegroup has changed
    if (
      props.pageIndex !== this.props.pageIndex ||
      props.filters !== this.props.filters ||
      props.pricegroup !== this.props.pricegroup
    ) {
      this.setState(this.initState());
    }
  }

  render = () => {
    const { widgets, progress, visible } = this.props;
    const { mouseXY } = this.state;

    /*

    Compare the width of footer to the width of the page
    and decide if the footer can be dragged.

    if (this.footer) {
      console.log(this.footer.offsetWidth);
      console.log(rootElement.offsetWidth);
    }

    */

    let [x, y] = mouseXY;

    if (!widgets) {
      return null;
    }

    let style = {
      translateX: spring(x, springSetting1),
    };

    return (
      <ReactCSSTransitionGroup
        transitionName="footerSlide"
        transitionAppear={false}
        transitionEnter={true}
        transitionLeave={true}
        transitionAppearTimeout={1500}
        transitionLeaveTimeout={1500}
        transitionEnterTimeout={1500}
      >
        {visible ? (
          <StyledFooter
            innerRef={footer => {
              this.footer = footer;
            }}
            className={'revieve-footer'}
            key={'footer'}
            onMouseDown={this.handleMouseDown.bind(null, 'footerMotion', [x, y])}
            onTouchStart={this.handleTouchStart.bind(null, 'footerMotion', [x, y])}
            minimized={this.props.minimized}
          >
            <Motion key={'footerMotion'} style={style}>
              {({ translateX }) => {
                return (
                  <StyledFooterWidgetContainer
                    ref={fwc => {
                      this.fwc = fwc;
                    }}
                    style={{ transform: `translate3d(${translateX}px, 0px, 0)` }}
                  >
                    {widgets}
                  </StyledFooterWidgetContainer>
                );
              }}
            </Motion>

            {progress}
          </StyledFooter>
        ) : null}
      </ReactCSSTransitionGroup>
    );
  };
}

export default Footer;



// WEBPACK FOOTER //
// ./src/components/instore/Footer.js